import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import {
  Button,
  Row,
  Col,
  Badge,
} from 'react-bootstrap';

const propTypes = exact({
  results: PropTypes.array.isRequired,
  requestAnotherDatePerDiemAction: PropTypes.func.isRequired,
  allowAdditionalRequests: PropTypes.bool.isRequired,
});


const PerDiemResults = (props) => {
  const perDiemStateAlertClass = (perDiemState) => {
    if (perDiemState === 'declined') {
      return 'alert-danger';
    } if (perDiemState === 'pending') {
      return 'alert-warning';
    }
    return 'alert-success';
  };

  const {
    results,
    requestAnotherDatePerDiemAction,
    allowAdditionalRequests,
  } = props;

  return (
    <React.Fragment>
      {results.map((userPerDiemResult) => {
        const alertClass = perDiemStateAlertClass(userPerDiemResult.state);
        const { notes } = userPerDiemResult;
        return (
          <div key={userPerDiemResult.user.id}>
            <span style={{ fontWeight: 'bold' }}>{userPerDiemResult.user.fullname}</span>
            :
            <Badge className={alertClass}>{userPerDiemResult.state}</Badge>
            {notes && <span> - {notes}</span>}
          </div>
        );
      })}

      {allowAdditionalRequests && (
        <Row style={{ paddingTop: '20px' }}>
          <Col sm={6} md={4} className="hidden-xs">
            <Button
              bsStyle="primary"
              onClick={requestAnotherDatePerDiemAction}
            >
              Request Another
            </Button>
          </Col>

          <Col xs={12} className="visible-xs">
            <Button
              style={{ width: '100%' }}
              bsStyle="primary"
              onClick={requestAnotherDatePerDiemAction}
            >
              Request Another
            </Button>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};


PerDiemResults.propTypes = propTypes;

export default PerDiemResults;
